import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { ComponentCategory } from '../enums'

export class WireframeComponentForm extends ObjetKForm {
  designSystemId: number = 0
  code: string = ''
  name: string = ''
  category: ComponentCategory = ComponentCategory.Form
  icon: string = ''
  definitionJson: string = '{}'
  propertiesSchemaJson: string = '{}'
  defaultPropertiesJson: string = '{}'
  thumbnail: string = ''
  defaultWidth: number = 100
  defaultHeight: number = 40
  order: number = 0
  isActive: boolean = true
  isSystem: boolean = false

  static validationRules = {
    designSystemId: combineRules(requiredRule('Le design system est obligatoire')),
    code: combineRules(requiredRule('Le code est obligatoire')),
    name: combineRules(requiredRule('Le nom est obligatoire'))
  }

  constructor(data?: Partial<WireframeComponentForm>) {
    super(data)
    if (data) {
      this.designSystemId = data.designSystemId ?? 0
      this.code = data.code ?? ''
      this.name = data.name ?? ''
      this.category = enumValue(ComponentCategory, data.category, ComponentCategory.Form)
      this.icon = data.icon ?? ''
      this.definitionJson = data.definitionJson ?? '{}'
      this.propertiesSchemaJson = data.propertiesSchemaJson ?? '{}'
      this.defaultPropertiesJson = data.defaultPropertiesJson ?? '{}'
      this.thumbnail = data.thumbnail ?? ''
      this.defaultWidth = data.defaultWidth ?? 100
      this.defaultHeight = data.defaultHeight ?? 40
      this.order = data.order ?? 0
      this.isActive = data.isActive ?? true
      this.isSystem = data.isSystem ?? false
    }
  }
}
